import useDownloadAppPopupStore from "./downloadapppopupstore";
import ReactDOM from "react-dom";
import { APKUrl, AppStoreButton, GooglePlayButton, IOSUrl } from "../topbanner";

const DownloadAppPopup = () => {
  const show = useDownloadAppPopupStore((state) => state.show);
  const setShow = useDownloadAppPopupStore((state) => state.setShow);

  if (show)
    return ReactDOM.createPortal(
      <div
        className="z-20 fixed top-0 left-0 w-screen h-screen flex items-center justify-center bg-[#00000062]"
        onClick={() => setShow(false)}
      >
        <div
          className="w-full rounded-3xl bg-[#2C2D36] mx-5 p-10 max-w-[575px] shadow-2xl shadow-[#292929]"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-center mb-2">
            <div
              className="w-[80px] h-[80px] rounded-lg"
              style={{
                backgroundImage: "url('/android-chrome-192x192.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </div>
          <p className="text-sm text-center">Download the Strikie App</p>

          <div className="text-center flex items-center justify-center mt-6 gap-5">
            <GooglePlayButton url={APKUrl} />
            <AppStoreButton url={IOSUrl} />
          </div>
        </div>
      </div>,
      document.body
    );
  return null;
};

export default DownloadAppPopup;
